"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportCompositePhoto = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var store_1 = require("../../../store");
var DataGrid_1 = require("../components/DataGrid");
var ImageGrid_1 = require("../components/ImageGrid");
var ImageWithTitle_1 = require("../components/ImageWithTitle");
var TitleBar_1 = require("../components/TitleBar");
var DataExtractor_1 = require("../DataExtractor");
var ReportHelpers_1 = require("../ReportHelpers");
var ReportBase_1 = require("./ReportBase");
var ReportCompositePhoto = /** @class */ (function (_super) {
    tslib_1.__extends(ReportCompositePhoto, _super);
    function ReportCompositePhoto(poles) {
        return _super.call(this, poles) || this;
    }
    ReportCompositePhoto.prototype.buildPDF = function () {
        var _this = this;
        this.poles.forEach(function (pole, i) {
            var job = store_1.AppStore.Tag.get(pole.jobId);
            var fullImages = [];
            var tagArr = [];
            var tagImageGrids = {};
            // Title
            _this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, _this.poles.length));
            pole.forEachField(function (field) {
                // Data grid of items outside of subforms
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        var extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    // Image grid
                    if (field instanceof core_shared_1.CollectionModelFieldImage) {
                        var captures = field.getCaptures();
                        captures.forEach(function (capture) {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                _this.images[imageReferenceString] = capture.medium.url;
                                if (!tagImageGrids[field.schema.displayName]) {
                                    tagImageGrids[field.schema.displayName] = [];
                                }
                                tagImageGrids[field.schema.displayName].push({ reference: imageReferenceString, timeStamp: new Date(capture.createdAt) });
                            }
                        });
                    }
                    // Truesize images
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        var captures = field.getCaptures();
                        captures.forEach(function (capture) {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                    _this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                    fullImages.push([field.schema.displayName, imageReferenceString]);
                                }
                            }
                        });
                    }
                }
            });
            // Top level data grid
            _this.nodes.push(new DataGrid_1.DataGrid(tagArr));
            // Tag image in a grid
            _this.nodes.push(new ImageGrid_1.ImageGrid(tagImageGrids));
            // Full size composite images
            fullImages.forEach(function (image) {
                _this.nodes.push(new ImageWithTitle_1.ImageWithTitle(image[0], { reference: image[1] }));
            });
        });
    };
    return ReportCompositePhoto;
}(ReportBase_1.ReportBase));
exports.ReportCompositePhoto = ReportCompositePhoto;
//# sourceMappingURL=ReportCompositePhoto.js.map